// Module
var code = "<page-header title=\"'Volume list'\" breadcrumbs=\"['Volumes']\" reload=\"true\"> </page-header>\n\n<volumes-datatable dataset=\"volumes\" on-remove=\"(removeAction)\" on-refresh=\"(getVolumes)\" is-browse-visible=\"showBrowseAction\"></volumes-datatable>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/volumes/volumes.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;